import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1f03526c")
const _hoisted_1 = { id: "wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "profile" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "chatItem"
}
const _hoisted_4 = { class: "f _2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "_img" }, null, -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "f _3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "_img" }, null, -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "f _4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "_img" }, null, -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 0,
  class: "f _guest"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "_img" }, null, -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 0,
  class: "chat me"
}
const _hoisted_21 = {
  key: 1,
  class: "chat they"
}
const _hoisted_22 = {
  key: 2,
  class: "chat they e"
}
const _hoisted_23 = {
  key: 3,
  class: "chat they"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MovingIcon = _resolveComponent("MovingIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "profile",
      class: _normalizeClass({spin:_ctx.stage>10})
    }, [
      _createElementVNode("div", {
        class: _normalizeClass({
        picture:true,
        enter:_ctx.stage>-1
      })
      }, [
        _hoisted_2,
        (_ctx.stage>0&&_ctx.stage<11)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.lobbyCode), 1))
          : _createCommentVNode("", true)
      ], 2)
    ], 2),
    (_ctx.stage>0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "friends",
          class: _normalizeClass({
      rotate:_ctx.stage>10,
    })
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            (_ctx.stage>1&&_ctx.stage<7)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_MovingIcon, {
                    name: "loader_dots",
                    autoplay: true,
                    loop: true
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.stage>6&&_ctx.stage<11)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_MovingIcon, {
                    name: "tick",
                    autoplay: true
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            (_ctx.stage>3&&_ctx.stage<8)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_MovingIcon, {
                    name: "loader_dots",
                    autoplay: true,
                    loop: true
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.stage>7&&_ctx.stage<11)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_MovingIcon, {
                    name: "tick",
                    autoplay: true
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            (_ctx.stage>2&&_ctx.stage<10)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_MovingIcon, {
                    name: "loader_dots",
                    autoplay: true,
                    loop: true
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.stage>9&&_ctx.stage<11)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_MovingIcon, {
                    name: "tick",
                    autoplay: true
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.stage>1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _hoisted_17,
                (_ctx.stage>5&&_ctx.stage<9)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_component_MovingIcon, {
                        name: "loader_dots",
                        autoplay: true,
                        loop: true
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.stage>8&&_ctx.stage<11)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createVNode(_component_MovingIcon, {
                        name: "tick",
                        autoplay: true
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.stage>11)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          id: "chat",
          class: _normalizeClass({s2:_ctx.stage>12,s3:_ctx.stage>13,s4:_ctx.stage>14,s5:_ctx.stage>15})
        }, [
          (_ctx.stage>11)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Ready to go? "))
            : _createCommentVNode("", true),
          (_ctx.stage>12)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, " let's do it! "))
            : _createCommentVNode("", true),
          (_ctx.stage>13)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, " 🙌🙌🙌 "))
            : _createCommentVNode("", true),
          (_ctx.stage>14)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, " 3... 2... 1... "))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}